
import React from 'react';
import OrdersTable from './OrdersTable';
import OrderPagination from './OrderPagination';

interface OrderDetails {
  order_id: string;
  user_email: string;
  amount: number;
  status: string;
  created_at: string;
  product_name: string;
  payment_method?: string;
}

interface PaginationInfo {
  page: number;
  pageSize: number;
  totalPages: number;
  totalCount: number;
}

interface OrdersViewProps {
  orders: OrderDetails[];
  pagination: PaginationInfo;
  onPageChange: (page: number) => void;
}

const OrdersView = ({ orders, pagination, onPageChange }: OrdersViewProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium mb-4">All Orders</h3>
      <OrdersTable orders={orders} />
      
      {pagination && pagination.totalPages > 1 && (
        <OrderPagination 
          currentPage={pagination.page}
          totalPages={pagination.totalPages}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default OrdersView;
